// Stub — WebSocket streaming non encore implémenté dans admin-web
export function chatWithLLMWebSocket(
  _messages,
  _context,
  _options,
  _socket,
  _onChunk,
  _onDone,
  _onError
) {
  console.warn('chatWithLLMWebSocket: WebSocket streaming non disponible');
  return () => {}; // cleanup no-op
}
